module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-base-shadow-10.e0de3b34.png";